export const SET_RESEND_TOKEN = 'SET_RESEND_TOKEN';
export const SET_REGISTER_INFORMATION = 'SET_REGISTER_INFORMATION';
export const SET_SHOW_REGISTER_ALERT = 'SET_SHOW_REGISTER_ALERT';
export const SET_LICENSE_KEY = 'SET_LICENSE_KEY';
export const SET_VALIDATION_ERROR = 'SET_VALIDATION_ERROR';
export const SHOW_VALIDATION_ERROR = 'SHOW_VALIDATION_ERROR';
export const RESET_SHOW_ERRORS = 'RESET_SHOW_ERRORS';
export const HIDE_VALIDATION_ERROR = 'HIDE_VALIDATION_ERROR';
export const LANGUAGE_CHANGE = 'LANGUAGE_CHANGE';

export const SET_LOGIN_FAILED = 'SET_LOGIN_FAILED';
export const TOKEN_EXPIRED = 'TOKEN_EXPIRED';

export const SET_LOGIN_STATE = 'SET_LOGIN_STATE';
export const SET_REGISTRATIONS = 'SET_REGISTRATIONS';
export const LOAD_REGISTRATION = 'LOAD_REGISTRATION';
export const LOAD_USAGE = 'LOAD_USAGE';
export const SET_LOADING_FLAG = 'SET_LOADING_FLAG';

export const SET_SETUP_MEETINGS = 'SET_SETUP_MEETINGS';
